import React, { useRef, useState, useEffect, useContext } from "react";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import { OptionDataContenxt } from "./OptionChartDashboard";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";
import InfoPopUp from "../../Common/InfoPopUp";

const OPTIONSOCKETSTREAMURL =
  "https://options-socket.paybito.com/oSocketStream/api";

const OptionBuyAndSellLimit = ({
  currencycode,
  basecurrency,
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  getUserTransaction,
  assetpair,
  selelectedMarginWalletBalance,
  selectedLeverageMarginType,
  selectedContractBalance,
  finalbaseLeverage,
  renderAvailableBalance,
  selectedOrderType,
  setLimitTrede,
  limitTrade,
}) => {
  const { sellData, buyData, lastAskItem, firstBidItem } =
    useContext(OptionDataContenxt);

  const tradep = 6;
  const theme = localStorage.getItem("theme");
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSell, setIsLoadingSell] = useState(false);
  const handleClose = () => setShow(false);

  const [limitAmount, setLimitAmount] = useState();
  const [limitPrice, setLimitPrice] = useState();
  const [limitAmountForOco1, setLimitAmountForOco1] = useState(0);
  const [limitPriceForOco1, setLimitPriceForOco1] = useState(0);
  const [limittriggerForOco1, setLimitTriggerForOco1] = useState(0);
  const [limitAmountForOco2, setLimitAmountForOco2] = useState(0);
  const [limitPriceForOco2, setLimitPriceForOco2] = useState(0);
  const [limittriggerForOco2, setLimitTriggerForOco2] = useState(0);
  const [isPlaceOrderEnabled, setIsPlaceOrderEnabled] = useState(false);
  const [isPlaceOrderEnabledForSell, setIsPlaceOrderEnabledForSell] =
    useState(false);
  const [limitValue, setLimitValue] = useState("");
  const [error, setError] = useState(false);
  const [limitAmountSell, setLimitAmountSell] = useState("");
  const [limitPriceSell, setLimitPriceSell] = useState("");
  const [limitValueSell, setLimitValueSell] = useState("");
  const [stpLoader, setStpLoader] = useState(false);

  useEffect(() => {
    checkUserBlockStatus();
  }, []);

  // useEffect(() => {
  //   setLimitPrice(buyData);
  //   const value = parseFloat(limitAmount) * parseFloat(buyData);
  //   setLimitValue(isNaN(value) ? "" : value.toFixed(tradep));
  //   resetSliderBuy();
  // }, [buyData]);
  // useEffect(() => {
  //   setLimitPriceSell(sellData);
  //   const valueSell = parseFloat(sellData) * parseFloat(limitAmountSell);
  //   setLimitValueSell(isNaN(valueSell) ? "" : valueSell.toFixed(tradep));
  //   resetSliderSell();
  // }, [sellData]);

  useEffect(() => {
    if (lastAskItem && lastAskItem.price && limitAmount) {
      const price = parseFloat(lastAskItem.price);
      const newPrice = (price - price * 0.02).toFixed(tradep);
      setLimitPrice(newPrice);
    }
  }, [lastAskItem, limitAmount]);

  useEffect(() => {
    if (firstBidItem && firstBidItem.price && limitAmountSell) {
      const price = parseFloat(firstBidItem.price);
      const newPrice = (price + price * 0.02).toFixed(tradep);
      setLimitPriceSell(newPrice);
    }
  }, [firstBidItem, limitAmountSell]);

  const checkUserBlockStatus = async () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    if (!uuid || !accessToken) {
      showToast("error", "Session Timeout. Login Again");
      //logout
      return false;
    }

    const payload = { uuid };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/userAccountStatus`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data?.error?.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        return false;
      }

      if (response.data.status !== 1) {
        showToast("error", "Your user has been blocked by Admin");
        return false;
      }

      return true;
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "Session Timeout. Login Again");
        //logout
      }
      return false;
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };
  const getAssetCode = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset ? asset.assetCode : "";
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return "";
    }
  };

  /* Get base and counter ID of a pair */
  const getAssetId = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset
        ? { baseCurrencyId: asset.baseCurrencyId, currencyId: asset.currencyId }
        : {};
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return {};
    }
  };

  const handleChange = (e) => {
    setLimitAmount(e.target.value);
  };

  const handleKeyUp = () => {
    validateLimit();
    resetSliderBuy();
    calculateLimitTotalFromAmount();
  };

  const validateLimit = () => {
    placeOrderForOcoBuy();
    placeOrderForOcoSell();
    const isInvalid = limitAmount <= 0.0001 || limitPrice <= 0.00000001;
    setError(isInvalid);
    return isInvalid;
  };

  const placeOrderForOcoBuy = () => {
    if (selectedOrderType === "OCO") {
      if (
        limitAmount <= 0.0001 ||
        limitPrice <= 0 ||
        limitAmountForOco1 <= 0.0001 ||
        limitPriceForOco1 <= 0 ||
        limittriggerForOco1 <= 0.0001
      ) {
        setIsPlaceOrderEnabled(false);
      } else {
        setIsPlaceOrderEnabled(true);
      }
    }
  };

  const placeOrderForOcoSell = () => {
    if (selectedOrderType === "OCO") {
      if (
        limitAmount <= 0.0001 ||
        limitPrice <= 0 ||
        limitAmountForOco2 <= 0.0001 ||
        limitPriceForOco2 <= 0 ||
        limittriggerForOco2 <= 0.0001
      ) {
        setIsPlaceOrderEnabledForSell(false);
      } else {
        setIsPlaceOrderEnabledForSell(true);
      }
    }
  };

  const resetSliderBuy = () => {
    setProgress(0);
  };
  const resetSliderSell = () => {
    setSliderValue(0);
  };

  const calculateLimitTotalFromAmount = () => {
    const total = (limitAmount * limitPrice).toFixed(8);
    setLimitValue(isNaN(total) ? "" : total);
  };

  const calculateAmountFromLimitForLimit = (type) => {
    if (type === "buy") {
      const value = parseFloat(limitAmount) * parseFloat(limitPrice);
      setLimitValue(isNaN(value) ? "" : value.toFixed(tradep));
      resetSliderBuy();
    } else {
      const valueSell =
        parseFloat(limitPriceSell) * parseFloat(limitAmountSell);
      setLimitValueSell(isNaN(valueSell) ? "" : valueSell.toFixed(tradep));
      resetSliderSell();
    }
    if (isNaN(limitAmount)) {
      setLimitAmount("");
    }
    if (isNaN(limitAmountSell)) {
      setLimitAmountSell("");
    }
  };

  const calculateAmountFromTotalForLimit = async (type, e) => {
    let inputValue = e.target.value;
    try {
      const response = await axios.get(`${OPTIONSOCKETSTREAMURL}/depth`, {
        params: {
          symbol: assetpair,
          limit: 1,
        },
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      });
      const data = response.data;

      if (type === "buy") {
        const price = parseFloat(data.ask[0].price);
        const calculatedLimitPrice = (price - price * 0.01).toFixed(tradep);
        const calculatedLimitAmount = (
          parseFloat(inputValue) / calculatedLimitPrice
        ).toFixed(tradep);
        // setLimitPrice(calculatedLimitPrice);
        setLimitAmount(calculatedLimitAmount);
        setLimitValue(inputValue);
      } else {
        const price = parseFloat(data.bid[0].price);
        const calculatedLimitPrice = (price + price * 0.01).toFixed(tradep);
        const calculatedLimitAmount = (
          parseFloat(inputValue) / calculatedLimitPrice
        ).toFixed(tradep);
        // setLimitPriceSell(calculatedLimitPrice);
        setLimitAmountSell(calculatedLimitAmount);
        setLimitValueSell(inputValue);
      }

      const isAmountValid =
        !isNaN(limitAmount) && parseFloat(limitAmount) > 0.0001;
      //   document.querySelector('.onlyBuyBtn').disabled = !isAmountValid;
    } catch (error) {
      console.error("Error fetching market depth:", error);
    }
  };

  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    getBuySliderValLimit(closestStep);
  };

  const getBuySliderValLimit = async (sliderValue) => {
    setStpLoader(true);

    let mwb = parseFloat(selelectedMarginWalletBalance);
    let leverage = finalbaseLeverage;
    let selectedPair = assetpair;
    let accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `${OPTIONSOCKETSTREAMURL}/depth?symbol=${selectedPair}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      let marketPrice = parseFloat(response.data.ask[0].price);
      let calculatedLimitAmount = (
        ((mwb * (sliderValue / 100) -
          mwb * (sliderValue / 100) * percentageValue) *
          leverage) /
        marketPrice
      ).toFixed(tradep);
      let calculatedLimitPrice =
        sliderValue === 0
          ? 0
          : (marketPrice - marketPrice * 0.01).toFixed(tradep);
      let calculatedLimitValue = (
        calculatedLimitAmount * calculatedLimitPrice
      ).toFixed(tradep);

      setLimitAmount(calculatedLimitAmount);
      setLimitPrice(calculatedLimitPrice);
      setLimitValue(calculatedLimitValue);
    } catch (error) {
      console.error("Error fetching market price:", error);
    }

    setStpLoader(false);
  };

  const limitBuy = async () => {
    setIsLoading(true);
    if (limitPrice * limitAmount > 0) {
      if (limitAmount && limitPrice) {
        const inputObj = {
          selling_asset_code: basecurrency?.toUpperCase(),
          buying_asset_code: currencycode?.toUpperCase(),
          amount: limitAmount,
          price: limitPrice,
          offerType: "L",
          txn_type: "1",
          assetPair: assetpair,
          leverage: finalbaseLeverage,
          uuid: localStorage.getItem("uuid"),
        };

        if (finalbaseLeverage > 1) {
          inputObj.marginType = selectedLeverageMarginType;
        }

        try {
          const response = await axios.post(
            `${WEBSERVICE}optionsTrade/TradeCreateOffer`,
            JSON.stringify(inputObj),
            {
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
            }
          );
          setIsLoading(false);
          if (response.data.error.error_data !== 0) {
            if (response.data.error.error_data === 1) {
              showToast("error", response.data.error.error_msg);
            } else {
              //   document.getElementById("warn").click();
            }
            setLimitPrice("");
            setLimitAmount("");
            setLimitValue("");
            setProgress(0);
          } else {
            showToast("success", response.data.error.error_msg);
            setLimitPrice("");
            setLimitAmount("");

            reset();
            // document.getElementById("trade").click();
          }
          setLimitTrede((prev) => !prev);
          if (finalbaseLeverage > 1) {
            renderAvailableBalance();
          } else {
            getUserTransaction();
          }
        } catch (error) {
          setIsLoading(false);
          console.error(error);
          showToast("error", "An error occurred");
        }
      } else {
        setIsLoading(false);
        showToast("warning", "Please provide proper buying details");
      }
    } else {
      setIsLoading(false);
      showToast("warning", "Your offer is too small");
    }
  };
  const reset = () => {
    setLimitAmount("");
    setLimitPrice("");
    setLimitValue("");
    setProgress(0);
  };
  const resetSell = () => {
    setLimitAmountSell("");
    setLimitPriceSell("");
    setLimitValueSell("");
    setSliderValue(0);
  };

  const validateLimitSell = () => {
    placeOrderForOcoBuy();
    placeOrderForOcoSell();

    if (limitAmountSell <= 0.0001) {
      //   document.querySelector('.onlySellError2')?.classList.add('show');
      disableButtons(true);
    } else {
      //   document.querySelector('.onlySellError2')?.classList.remove('show');
      disableButtons(false);
    }
    return 0.0001 >= limitAmountSell || 0.00000001 >= limitPriceSell;
  };

  const calculateLimitTotalFromAmountSell = () => {
    const total = (limitAmountSell * limitPriceSell).toFixed(8);
    setLimitValueSell(isNaN(total) ? "" : total);
  };

  const disableButtons = (disable) => {
    // document.getElementById('mbuy')?.setAttribute('disabled', disable);
    // document.getElementById('msell')?.setAttribute('disabled', disable);
    // document.getElementById('onlySellBtn')?.setAttribute('disabled', disable);
  };

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    getSellSliderValLimit(closestStep);
  };

  const getSellSliderValLimit = (sliderValue) => {
    axios
      .get(`${OPTIONSOCKETSTREAMURL}/depth?symbol=${assetpair}&limit=1`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const marketPrice = parseFloat(response.data.bid[0].price);
        const mwb = parseFloat(selelectedMarginWalletBalance);
        const leverage = finalbaseLeverage;

        const calculatedLimitAmountSell = (
          ((mwb * (sliderValue / 100) -
            mwb * (sliderValue / 100) * percentageValue) *
            leverage) /
          marketPrice
        ).toFixed(tradep);

        setLimitAmountSell(calculatedLimitAmountSell);

        let calculatedLimitPriceSell = 0;
        if (sliderValue !== 0) {
          calculatedLimitPriceSell = (marketPrice - marketPrice * 0.01).toFixed(
            tradep
          );
        }

        setLimitPriceSell(calculatedLimitPriceSell);
        setLimitValueSell(
          (calculatedLimitAmountSell * calculatedLimitPriceSell).toFixed(tradep)
        );

        // Validate the limit (based on your existing logic)
        validateLimitSell();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const limitSell = async () => {
    setIsLoadingSell(true);
    if (limitPriceSell && limitAmountSell) {
      if (limitPriceSell * limitAmountSell > 0) {
        const inputObj = {
          selling_asset_code: currencycode?.toUpperCase(),
          buying_asset_code: basecurrency?.toUpperCase(),
          amount: limitAmountSell,
          price: limitPriceSell,
          offerType: "L",
          txn_type: "2",
          assetPair: assetpair,
          leverage: finalbaseLeverage,
          uuid: localStorage.getItem("uuid"),
        };

        if (finalbaseLeverage > 1) {
          inputObj.marginType = selectedLeverageMarginType;
        }

        try {
          const response = await axios.post(
            `${WEBSERVICE}optionsTrade/TradeCreateOffer`,
            inputObj,
            {
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
            }
          );
          setIsLoadingSell(false);
          const result = response.data;
          if (result.error.error_data !== 0) {
            if (result.error.error_data === 1) {
              showToast("error", result.error.error_msg);
            } else {
              //   setAlertMessage('Warning message');
              //   setAlertType('warning');
            }
            setLimitPriceSell("");
            setLimitAmountSell("");
            setLimitValueSell("");
            setSliderValue(0);
          } else {
            showToast("success", result.error.error_msg);
            if (finalbaseLeverage > 1) {
              renderAvailableBalance();
            } else {
              getUserTransaction();
              // this.renderContractBalance();
            }

            resetSell();
            setLimitTrede((prev) => !prev);
          }
        } catch (error) {
          setIsLoadingSell(false);
          showToast("error", "An error occurred");
        }
      } else {
        setIsLoadingSell(false);
        showToast("warning", "Your offer is too small");
      }
    } else {
      setIsLoadingSell(false);
      showToast("warning", "Please provide proper selling details");
    }
  };

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY PANEL ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">
            Buy {currencycode?.toUpperCase()}
          </div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={limitAmount}
                onChange={handleChange}
                onKeyUp={handleKeyUp}
                required
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={isNaN(limitPrice) ? 0 : limitPrice}
                onChange={(e) => setLimitPrice(e.target.value)}
                onKeyUp={() => {
                  validateLimit();
                  calculateAmountFromLimitForLimit("buy");
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={isNaN(limitValue) ? 0 : limitValue}
                onChange={(e) => setLimitValue(e.target.value)}
                onKeyUp={(event) => {
                  calculateAmountFromTotalForLimit("buy", event);
                  resetSliderBuy();
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={progressBarRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${
                  progress === pct ? "pct-active-buy" : ""
                }`}
                onClick={() => {
                  setProgress(pct);
                  getBuySliderValLimit(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-buy"
            disabled={!(limitValue > 0) || isLoading}
            onClick={limitBuy}
          >
            {isLoading ? "Loading..." : `BUY ${currencycode?.toUpperCase()}`}
          </button>
        </div>

        {/* ── SELL PANEL ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">
            Sell {currencycode?.toUpperCase()}
          </div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={limitAmountSell}
                onChange={(e) => setLimitAmountSell(e.target.value)}
                onKeyUp={() => {
                  validateLimitSell();
                  resetSliderSell();
                  calculateLimitTotalFromAmountSell();
                }}
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={isNaN(limitPriceSell) ? 0 : limitPriceSell}
                onChange={(e) => setLimitPriceSell(e.target.value)}
                onKeyUp={() => {
                  validateLimitSell();
                  calculateAmountFromLimitForLimit("sell");
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={isNaN(limitValueSell) ? 0 : limitValueSell}
                onChange={(e) => setLimitValueSell(e.target.value)}
                onKeyUp={(event) => {
                  calculateAmountFromTotalForLimit("sell", event);
                  resetSliderSell();
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={sliderRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${
                  sliderValue === pct ? "pct-active-sell" : ""
                }`}
                onClick={() => {
                  setSliderValue(pct);
                  getSellSliderValLimit(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-sell"
            disabled={!(limitValueSell > 0) || isLoadingSell}
            onClick={limitSell}
          >
            {isLoadingSell
              ? "Loading..."
              : `SELL ${currencycode?.toUpperCase()}`}
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title="Limit"
        description={`You can create Buy and Sell limit offers at the price of your choice and the offers will reflect in Order Book and Open Orders.`}
      />
    </div>
  );
};

export default OptionBuyAndSellLimit;
